import Dropdown from '../Dropdown'
import HookFormHoc from './HookFormHoc'

export default HookFormHoc(Dropdown)
